<script lang="ts">
    import { onMount } from 'svelte';

    export let id: string;
    export let label: string;
    export let value: string = '';
    export let placeholder: string = '';
    export let autocomplete: AutoFill = 'current-password';
    export let error: string = '';
    export let disabled: boolean = false;
    export let autofocus: boolean = false;

    let showPassword = false;
    let inputEl: HTMLInputElement;

    onMount(() => {
        if (autofocus) inputEl?.focus();
    });

    function handleInput(e: Event) {
        value = (e.currentTarget as HTMLInputElement).value;
    }
</script>

<div class="auth-form-field" class:error={!!error}>
    {#if label || $$slots['label-action']}
        <div class="password-label-wrapper">
            {#if label}<label class="auth-form-label" for={id}>{label}</label>{/if}
            <slot name="label-action" />
        </div>
    {/if}
    <div class="auth-password-wrap">
        <input
            bind:this={inputEl}
            {id}
            class="auth-form-input"
            type={showPassword ? 'text' : 'password'}
            {autocomplete}
            {placeholder}
            {disabled}
            {value}
            on:input={handleInput}
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? `${id}-error` : undefined}
        />
        <button
            type="button"
            class="auth-password-toggle"
            on:click={() => (showPassword = !showPassword)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            aria-pressed={showPassword}
            {disabled}
        >
            <i class="{showPassword ? 'eye slash' : 'eye'} icon" aria-hidden="true"></i>
        </button>
    </div>
    {#if error}
        <span id="{id}-error" class="auth-error-message" role="alert">{error}</span>
    {/if}
</div>
